export default __webpack_public_path__ + "images/7378bc33f36ff8b40e5ccdba2c472cb6.svg";